export default __webpack_public_path__ + "static/media/logo-dxg-no-bg.67dfdae5.svg";